<div class="card mt-3 shadow-sm">
  <div class="card-header bg-light d-flex align-items-center">
    <h3 class="card-title m-0">Welcome Letter</h3>
  </div>

  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }

    @if (welcomeLetterSent) {
      <div class="mb-3">
        <div class="d-flex align-items-center">
          <span class="me-2">Welcome letter sent on</span>
          <span class="badge bg-success">{{ sentDate }}</span>
        </div>
      </div>
    }

    <form [formGroup]="form" class="row">
      <div class="col-md-9">
        <select-field
          label="Choose a person"
          [selectFormControl]="getRecipientSelect()"
          [options]="recipientOptions"
          [readonly]="false">
        </select-field>
      </div>
      <div class="col-md-3 d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="form.invalid || readonlyWelcomeLetter"
          (click)="sendWelcomeLetter()">
          <i class="fa fa-solid fa-paper-plane me-1"></i> Send welcome letter
        </button>
      </div>
    </form>

    @if (welcomeLetterSent) {
      <div class="table-responsive mt-4">
        <table class="table text-center">
          <thead>
            <tr>
              <th class="text-center">NAME</th>
              <th class="text-center">EMAIL RECIPIENT</th>
              <th class="text-center">DATE</th>
            </tr>
          </thead>
          <tbody class="align-middle">
            @for (letter of personSentWelcomeLetter; track letter) {
              <tr>
                <td>{{ getFullName(letter) }}</td>
                <td>{{ letter.recipient }}</td>
                <td>{{ letter.createTime | date:'yyyy-MM-dd HH:mm:ss' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
